<template>
  <div class="filters__unner">
    <h2>Выбрать по параметрам</h2>
    <div class="filters__filter-block">
      <form @submit.prevent="fetchProducts">
        <div class="filters__top">
<!--          <div class="filters__filter" v-if="manufacturer_options.length">
            <vs-select
                v-model="filters.manufacturer"
                :multiple="false"
                :options="manufacturer_options"
                placeholder="Выбрать производителя"
                @update:modelValue="fetchFilters"
            />
          </div>-->

          <div class="filters__filter">
            <vs-select
                v-model="filters.brand"
                :multiple="false"
                :options="brand_options"
                placeholder="Выбрать бренд"
                @update:modelValue="fetchFilters"
            />
          </div>

          <button type="submit" class="filters__product-button">Показать товары</button>
        </div>
        <div class="filters__bottom">
          <div class="filters__filter" v-for="(filter, key) in availableFilters" :key="key">
            <vs-select
                v-model="filters[key]"
                :multiple="false"
                :options="filter"
                :placeholder="`${key}`"
            />
          </div>
        </div>
      </form>
    </div>
  </div>


  <div class="filters__cards-block">
    <div class="filters__cards-buttons">
      <!--      <button>В наличии</button>-->
      <button class="activeButtonCard" @click="fetchProducts('discount')">Акции и распродажи</button>
      <button @click="fetchProducts('popular')">Популярное</button>
      <button @click="fetchProducts('cheap')">Сначала недорогие</button>
    </div>
    <div class="filters__cards-content">
      <div class="filters__cards"><!-- Первый блок товаров (до 8) -->
        <ProductItem
            v-for="product in products.slice(0, 8)"
            :key="product.id"
            :product="product"
            @add-to-cart="addToCart"
            :is-auth="isAuth"
        />
      </div>

      <ExclusivesDiscount v-if="!isAuth" />

      <!-- Второй блок товаров (остальные) -->
      <div class="filters__cards">
        <ProductItem
            v-for="product in products.slice(8)"
            :key="product.id"
            :product="product"
            @add-to-cart="addToCart"
            :is-auth="isAuth"
        />

      </div>
    </div>
  </div>

  <PaginationProducts
      v-model="currentPage"
      :page-count="totalPages"
      @page-changed="handlePageChange"
  />


</template>

<script>
import Treeselect from '@zanmato/vue3-treeselect';
import VsSelect from 'vs-vue3-select';
import cart from '../scripts/shop-cart';
import axios from 'axios';
import ProductItem from '../components/ProductItem.vue';
import ExclusivesDiscount from "./ExclusivesDiscount.vue";
import PaginationProducts from "./PaginationProducts.vue";

export default {
  components: {ExclusivesDiscount, Treeselect, VsSelect, ProductItem, PaginationProducts,},
  data() {
    return {
      product_collection_options: [],
      brand_options: [],
      manufacturer_options: [],
      isAuth: window.IS_AUTHENTICATED,
      filters: {
        product_collection: null,
        brand: [],
        // manufacturer: [],
      },
      availableFilters: {},
      products: [],
      totalPages: 0, // Общее количество страниц
      currentPage: 1, // Текущая страница
      limit: 16,
      isFirstLoad: true,
    };
  },
  methods: {
    async fetchProducts(order_by = '') {
      console.log('Filters:', this.filters);

      // Собираем все фильтры в один объект для запроса
      let query = {};
      let slug_product_collection;
      const currentPath = window.location.pathname;
      // Check if the path contains a slug (assuming the slug is the last part of the path)
      const pathParts = currentPath.split('/');

      if (pathParts.length === 3) {
        slug_product_collection = pathParts[2];
      } else {
        slug_product_collection = 'tovary-dlya-domashnih-jivotnyh';
      }
      query['product_collection'] = slug_product_collection;
      // Добавляем динамические фильтры
      for (const key in this.filters) {
        if (this.filters[key] && this.filters[key].length > 0) {
          query[key] = this.filters[key];
        }
      }

      if (typeof order_by === 'string' || order_by instanceof String) {
        const order_params = ['discount', 'popular', 'cheap'];
        const is_order_by = order_params.includes(order_by);
        if (is_order_by)
          query['order_by'] = order_by;
      }

      query['page'] = this.currentPage;

      // Выполняем запрос к API
      axios.post('/api/products', query)
          .then(response => {
            console.log('Products fetch response:', response.data);
            this.totalPages = response.data.totalPages;
            this.products = response.data.products;

          })
          .catch(error => {
            console.error('Error fetching products:', error);
            alert("Ошибка при загрузке продуктов: " + error.message);
          });
    },
    async fetchFilters() {
      let query, slug_product_collection;

      const currentPath = window.location.pathname;
      // Check if the path contains a slug (assuming the slug is the last part of the path)
      const pathParts = currentPath.split('/');

      if (pathParts.length === 3) {
        slug_product_collection = pathParts[2];
      } else {
        slug_product_collection = 'tovary-dlya-domashnih-jivotnyh';
      }

      query = `product_collection=${slug_product_collection}`;

     /* if (this.filters.brand) {
        query += `&brand=${this.filters.brand}`;
      }*/
      if (this.filters.manufacturer) {
        query += `&manufacturer=${this.filters.manufacturer}`;
      }

      const response = await fetch(`/api/filters?${query}`);
      let responsejson = await response.json();
      console.log('json:', responsejson);

      let top_filters = responsejson.top_filters;

      // Преобразуем объекты в массивы
      this.brand_options = top_filters.brands;
      this.manufacturer_options = top_filters.manufacturers;
      this.product_collection_options = top_filters.categories;

      this.availableFilters = responsejson.bottom_filters;
      if (this.isFirstLoad) {
        this.isFirstLoad = false; // Сбрасываем флаг после первой загрузки
        this.fetchProducts();
      }
    },
    handlePageChange(pageNumber) {
      this.currentPage = pageNumber;
      this.fetchProducts();
    },
    async fetchCategories() {
      const response = await fetch(`/api/categories`);
      this.product_collection_options = await response.json();
    },
    addToCart(productId) {

      let modalBasketAdd = document.querySelector('.modal-basket');

      cart.addItem(productId, 1).then(function (data) {
        let product_image = modalBasketAdd.querySelector('.product-image img');
        let product_name = modalBasketAdd.querySelector('a.product-name');
        let product_price_one = modalBasketAdd.querySelector('span.product-price');
        let product_desc = modalBasketAdd.querySelector('p.desc-cart-item');
        let item_active = data['cart_item']['item_active'];
        let quantity = item_active['quantity'];
        let price = item_active['price'];

        product_image.src = '/images/products/' + item_active.image;
        product_name.textContent = item_active.name;
        product_price_one.textContent = price + ' р';

        const wordForms = ['товар', 'товара', 'товаров'];
        const lastDigit = quantity % 10;
        const lastTwoDigits = quantity % 100;
        let wordForm
        if (lastTwoDigits >= 11 && lastTwoDigits <= 14) {
          wordForm = wordForms[2]; // "товаров"
        } else {
          if (lastDigit === 1) {
            wordForm = wordForms[0]; // "товар"
          } else if (lastDigit >= 2 && lastDigit <= 4) {
            wordForm = wordForms[1]; // "товара"
          } else {
            wordForm = wordForms[2]; // "товаров"
          }
        }
        // Перемножаем количество и цену и округляем до целого числа
        const totalPrice = Math.round(quantity * price);
        product_desc.textContent = 'В корзине ' + quantity + ' ' + wordForm + ' на сумму ' + totalPrice + ' р';

        modalBasketAdd.classList.add('activeModalBasket');
      }).catch(function (error) {
        console.error('Error adding item to cart:', error);
        this.showError('Ошибка при добавлении товара в корзину.');
      }.bind(this));

    },
  },
  mounted() {
    this.fetchFilters();
    this.fetchProducts();
  },
};
</script>